export default __webpack_public_path__ + "static/media/paynow-logo-2.c94bc7ce.png";